<template>
  <div class="div_qi">
    <h3 class="h3">{{ form.name }}</h3>
    <div :class="['img',noneCoupon? 'none-coupon-bac ':'']">
      <!-- <div class="have-been" v-if="noneCoupon">已使用</div> -->
      <van-image
        width="185px"
        height="185px"
        fit="cover"
        :src="form.qrCodePicUrl"
      />
    </div>
    <div :class="['bg-new',noneCoupon? 'none-coupon-bac ':'']" v-if="form.couponVos && form.couponVos.length > 1">
      <div class="bg-title" :style="form.isUsed != 0?'color:#ccc':''">券码信息({{form.couponVos?form.couponVos.length:''}})</div>
      <div
        class="bg-code"
        v-for="(item,index) in form.couponVos"
        :key="index"
      >
        <div :class="item.isUsed != 0?'code-none':''">{{item.couponCode}}</div>
        <div
          style="color:#F8A651"
          v-if="item.isUsed == 0"
        >未使用</div>
        <div
          style="color:#cccccc"
          v-if="item.isUsed == 1"
        >已使用</div>
        <div
          style="color:#cccccc"
          v-if="item.isUsed == 2"
        >已过期</div>
        <div
          style="color:#cccccc"
          v-if="item.isUsed == 3"
        >已失效</div>
      </div>
    </div>
    <div class="bg" v-else>
      <div :class="form.isUsed != 0 ? 'num none' : 'num selected'" >{{ form.couponCode }}</div>
    </div>
    <!-- 二维码遮罩层 -->
    <div
      class="mask"
      v-show="form.isUsed != 0"
    ></div>
    <div
      class="expired"
      v-show="form.isUsed != 0"
    >{{ qrStatus }}</div>
    <div
      class="tip"
      v-show="!noneCoupon"
    >二维码有效期为一分钟，请及时核销。若失效可点击“刷新”按钮
      向商家出示券码或二维码即可消费。</div>
    <h4 class="info">使用说明</h4>
    <div class="siv_1">
      <!-- <div class="siv_2">
        <p class="title_p">适用时段</p>
        <p class="c9">0:00-24:00</p>
      </div> -->
      <div class="siv_3">
        <p class="title_p">有效期</p>
        <p class="c9">
          {{ form.beginTime && form.beginTime}} - {{ form.endTime && form.endTime}}
        </p>
      </div>
    </div>
    <div class="siv_1" v-if="form.useTimeLimit">
      <div class="siv_3" v-if="form.useTimeLimit.type == 1 || form.useTimeLimit.type == 2">
        <p class="title_p">可使用时间段</p>
         <div class="right-usetime"  v-if="form.useTimeLimit.type == 1">
              <div v-for="(item,index) in form.useTimeLimit.ableTimeList" :key="index">
                  {{item.timeLimitDesc}}
              </div>
         </div>
           <div class="right-usetime"  v-if="form.useTimeLimit.type == 2">
              <div v-for="(item,index) in form.useTimeLimit.ableWeekdayList" :key="index">
                  {{item.timeLimitDesc}}
              </div>
         </div>
      </div>
    </div>
    <div class="siv_1" v-if="form.disableDateListDesc">
      <div class="siv_3">
        <p class="title_p">不可用日期</p>
        <div class="right-usetime">
              {{ form.disableDateListDesc}}
        </div>
      </div>
    </div>
    <div class="rule" v-if="form.ruleDesc">
      <p class="title_p">使用规则</p>
      <p
        class="c9"
        v-html="form.ruleDesc"
      ></p>
    </div>
    <div class="hr"></div>
    <div >
      <h4 class="h4 bottom20">
        <div>适用商家</div>
        <div :class="['list-count',noneCoupon? 'none-coupon ':'' ]">{{form.branchIdList?form.branchIdList.length:''}}</div>
      </h4>
      <div class="scope">
        <div class="stores">
          <div :class="['item-box',!isShowBtn?'hov':'']">
            <div
              class="item"
              v-for="(item,index) in form.branchIdList"
              :key="index"
            >
              <div class="left">
                <img class="image" :src="item.brandImageInfo" />
              </div>
              <div class="right"> {{ item.branchName || item.storeCode}} </div>
            </div>
          </div>
          <div v-if="form.branchIdList.length>6" class="see"  @click="onSeeMoreClick">
            {{!isShowBtn?'点击查看更多店铺':'收起'}}
          </div>
        </div>
      </div>
    </div>
    <van-dialog  v-model="showResult" confirm-button-text="刷新二维码" confirm-button-color="#007AFF"   @confirm="refreshTwo">
        <div class="dia-content">
          <div class="dia-title">提示</div>
          <div class="dia-tip tip-one" v-if="resultForm.cancelStatus == 0">
            <img class="tip-success " src="@/assets/image/success-icon@2x.png">
            共<span style="color:#ED3939">{{resultForm.cancelSuccessNum}}</span>张,核销成功！</div>
          <div class="dia-tip tip-two" v-if="resultForm.cancelStatus == 1">
            <img class="tip-error" src="@/assets/image/error-icon@2x.png">共<span>{{form.canCancelNum}}</span>张,核销失败{{resultForm.cancelFailNum}}张,核销成功<span style="color:#3FAE7D">{{resultForm.cancelSuccessNum}}</span>张！</div>
          <div class="dia-tip tip-one" v-if="resultForm.cancelStatus == 2"><img class="tip-error" src="@/assets/image/error-icon@2x.png">共<span style="color:#ED3939">{{resultForm.cancelFailNum}}</span>张</div>
          <div class="tips" v-if="resultForm.cancelStatus == 1 || resultForm.cancelStatus == 2">请检查优惠券是否已被核销！</div>   
        </div>
          
    </van-dialog>
    <!-- 刷新 -->
    <div
      class="refresh"
      v-show="form.isUsed == 0"
    >
      <div
        class="btn"
        @click="refresh"
      >刷新</div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
export default {
  name: "",
  props: {},
  data() {
    return {
      form: {},
      btnLoading: false,
      code: this.$route.query.code,
      loadNum: 8,
      isShowBtn: false,
      qrStatus: "",
      noneCoupon: true,
      showResult:false,
      resultForm:{}
    };
  },
  methods: {
    showMore() {
      this.loadNum = 9000;
      this.isShowBtn = false;
    },
    toStoreList() {
      this.$router.push({
        name: "storeList",
        query: {
          code: this.$route.query.code,
        },
      });
    },
    init() {
      http({
        url: "order/coupon/queryCouponByCode/" + this.code,
        method: "get",
        parmes: {},
      })
        .then((rps) => {
          this.form = rps.data;
          this.code =rps.data.couponCode
          this.noneCoupon = rps.data.couponVos.every((item, index) => {
            return item.isUsed > 0;
          });
          if (rps.data.viewType == 1 && rps.data.branchIdList.length >= 9) {
            this.isShowBtn = true;
          }
          switch (rps.data.isUsed) {
            case 1:
              this.qrStatus = "已使用";
              break;
            case 2:
              this.qrStatus = "已过期";
              break;
            default:
              this.qrStatus = "不可使用";
              break;
          }
          this.$loading.hide();
          clearInterval(this.inteervalMessage)
          this.inteervalMessage = setInterval(()=>{
            this.getMessage()
          },3000)
          
        })
        .catch(() => {});
    },
    refresh() {
      this.$loading.show();
      this.init();
    },
    refreshTwo(){wss://api.chinabeego.com
      this.showResult = false
      this.refresh()
    },
    getMessage(){
      http({
            url:"order/coupon/query/cancelMsg/"+this.code,
            method: "get",
        parmes: {},
          }).then((rps)=>{

            if(rps.data){
              
              this.resultForm = rps.data
              this.showResult = true
              clearInterval(this.inteervalMessage);

            }
            
          }).catch(()=>{

          })
    },
    onSeeMoreClick(){
      this.isShowBtn = !this.isShowBtn;
    },
    
  },
  created() {
    this.init();  
  },
  
  beforeDestroy(){
    clearInterval(this.inteervalMessage)
  }
};
</script>
<style lang="less" scoped>
.div_qi {
  position: relative;
  border-top: 1px solid #eee;
  padding-left: 60px;
  padding-right: 60px;
   padding-bottom: 25%;
  font-size: 28px;
  background: #ffffff;
  color: #333333;
  padding-top: 40px;
  //   height: 120%;
  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 73px;
    text-align: center;
    background: #ffedee;
    font-size: 20px;
    color: #ed3939;
    padding: 10px 30px;
  }
  .h3 {
    font-size: 32px;
    margin-bottom: 25px;
    text-align: center;
  }
  .img {
    text-align: center;
    background: #f7f7f7;
    padding-top: 30px;
    padding-bottom: 30px;
    position: relative;
    .have-been {
      position: absolute;
      width: 180px;
      height: 70px;
      background: #ffffff;
      border-radius: 40px;
      border: 1px solid #999999;
      line-height: 70px;
      text-align: center;
      color: #999999;
      z-index: 999;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
    }
  }
  .num {
    max-width: 630px;
    word-wrap: break-word;
    background-color: var(--buttonColor);
    color: var(--textColor);
    font-size: 46px;
    text-align: center;
    font-weight: bold;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }
  .info {
    font-size: 32px;
    margin-top: 30px;
    font-weight: bold;
  }
  .c9 {
    color: #999999;
    margin-top: 1px;
  }
  .siv_1 {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
  .hr {
    height: 1px;
    background: #cccccc;
    margin-top: 20px;
  }
  .h4 {
    font-size: 32px;
    margin-top: 20px;
    margin-bottom: 40px;
  }
  .bgary {
    background: #f7f7f7;
    margin-top: 20px;
    padding: 30px;
    font-size: 24px;
    text-align: left;
    h5 {
      font-size: 24px;
    }
    p {
      margin-top: 10px;
      color: #999999;
    }
  }
}
.refresh {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 120px;
  border-top: 1px solid #dddddd;
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 600px;
    height: 88px;
    background-color: #f8d541;
    border-radius: 44px;
    font-weight: 500;
    color: #333333;
    font-size: 26px;
  }
}
.bg {
  background-color: #f7f7f7;
  .num {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 630px;
    width: 100%;
    height: 100px;
    word-wrap: break-word;
    font-size: 42px;
    font-weight: 500;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
  }
  .none {
    background-color: #dddddd;
    color: #ccc;
  }
  .selected {
    background-color: var(--buttonColor);
    color: var(--textColor);
  }
}
.mask {
  position: absolute;
  top: 113px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 630px;
  height: 400px;
  background: #f7f7f7;
  opacity: 0.8;
}
.expired {
  position: absolute;
  top: 285px;
  left: 285px;
  width: 180px;
  height: 70px;
  background-color: #fff;
  text-align: center;
  line-height: 75px;
  border-radius: 40px;
  border: 1px solid #999;
  font-size: 24px;
  color: #999;
}
.div_qi_footer {
  margin-left: -60px;
  margin-right: -60px;
  margin-top: 21px;
  border-top: 1px solid #cccccc;
  padding-top: 15px;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .btn_l {
    margin-left: 40px;
  }
  .btn_r {
    margin-right: 40px;
  }
  .btn {
    width: 298px;
    height: 68px;
    border-radius: 32px;
  }
  .gy {
    background: #ffffff;
    border: 1px solid #999999;
    color: #999999;
  }
  .wt {
    background: #f8d541;
    border: 1px solid #f8d541;
    color: #333333;
  }
}
.title {
  position: relative;
}
.red_num {
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  width: 40px;
  height: 30px;
  background: #e74a4a;
  border-radius: 15px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 30px;
  text-align: center;
}
.rule {
  margin-top: 20px;
}
.logo_box_div {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.logo_box_div:after {
  content: "";
  width: 33%;
}
.logo_box_div .logo_box:nth-child(3n-1) {
  margin: 0 90px;
}
.logo_box {
  margin-bottom: 20px;
  img {
    width: 110px;
    height: 70px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-bottom: 16px;
    margin: 0 auto;
    padding: 15px;
  }
  span {
    display: block;
    width: 140px;
    height: 100px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-bottom: 16px;
    line-height: 60px;
    text-align: center;
    font-size: 80px;
    color: #f2f2f2;
  }
}
.logo_name {
  text-align: center;
  width: 144px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 33px;
  margin: 10px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logo {
  width: 140px;
  height: 100px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.oneBig {
  width: 100%;
  img {
    width: 400px;
    height: 300px;
    display: block;
    margin: 0 auto;
  }
  .logo_name {
    width: 100%;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    margin-top: 19px;
  }
}
.title_p {
  font-weight: bold;
}
.bg-new {
  background-color: #fffae4;
  padding: 20px 30px 20px;
  .bg-title {
    font-weight: bold;
  }
  .bg-code {
    margin-top: 10px;
    height: 40px;
    display: flex;
    justify-content: space-between;
    .code-none {
      text-decoration: line-through;
      color:#ccc
    }
  }
}
.bottom20 {
  margin-bottom: 20px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.list-count {
  padding: 0 13px;
  background: #e74a4a;
  border-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 22px;
}
.none-coupon {
  background-color: #ccc !important;
}
.none-coupon-bac {
  background-color: #f7f7f7 !important;
}
.dia-content{
  display: flex;
  flex-direction: column;
  align-items: center;
  .dia-title{
    padding: 30px 0 20px;
  }
  .tip-one{
    padding-bottom: 55px;
  }
  .tip-two{
    padding-bottom: 25px;
  }
  .dia-tip{
    color: #666666;
    font-size: 28px;
    display: flex;
    align-items: center;
    .tips{
      font-size: 24px;
      color: #999999;
      padding-bottom: 22px;
    }
    .tip-success{
      width: 36px;
      height: 36px;
      
      margin-right: 10px;
     
    }
    .tip-error{
        width: 36px;
      height: 36px;
     
      
      margin-right: 10px;
    }
    span{
      color: #ED3939;
    }
  }
  
}

.scope {
  // padding: 24px;
}

.scope .head {
  display: flex;
  justify-content: space-between;
  font-size: 26px;
  color: #808080;
  height: 48px;
}

.scope .view {
  display: flex;
  align-items: center;
}

.scope .arrow {
  display: block;
  width: 48px;
  height: 48px;
}

.scope .shop {
  color: #4088ee;
  font-size: 26px;
  line-height: 34px;
}

.scope .goods {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.scope .goods .item {
  width: 156px;
  height: 156px;
  border-radius: 8px;
  overflow: hidden;
}

.scope .goods .image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.scope .stores .item-box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
  overflow: hidden;
}
.hov{
  height: 400px;
  overflow: hidden;
}

.scope .stores .item {
  flex-shrink: 0;
  width: calc(50% - 12px);
  height: 122px;
  margin-right: 12px;
  margin-bottom: 12px;
  display: flex;
  padding: 24px 12px;
  box-sizing: border-box;
  box-shadow: 0px 0px 8px 0px rgba(216, 220, 230, 0.5);
  border-radius: 8px;
}

.scope .stores .left {
  flex-shrink: 0;
  position: relative;
}

.scope .stores .left::after {
  content: ' ';
  position: absolute;
  left: 0;
  top: 0;
  pointer-events: none;
  box-sizing: border-box;
  -webkit-transform-origin: 0 0;
  transform-origin: 0 0;
  width: 199.8%;
  height: 199.7%;
  transform: scale(0.5, 0.5);
  border: 1px solid #e1e1e1;
  z-index: 2;
}

.scope .stores .image {
  display: block;
  width: 112px;
  height: 74px;
  object-fit: contain;
  position: relative;
}

.scope .stores .right {
  padding-left: 12px;
  font-size: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 36px;
  height: 72px;
}

.scope .stores .see {
  padding-top: 24px;
  padding-bottom: 12px;
  color: #4088ee;
  font-size: 26px;
  text-align: center;
}
.right-usetime{
  color:#999;
}
</style>